/* ============================================
   NEW HERO CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const isDesignMode = typeof window.Shopify !== 'undefined' && Boolean(window.Shopify.designMode);
    function initHero(hero) {
        if (hero.dataset.carouselInitialized === 'true') return;
        hero.dataset.carouselInitialized = 'true';

        const slides = hero.querySelectorAll('.hero__slide');
        const dots = hero.querySelectorAll('.hero__dot');
        const prevButton = hero.querySelector('.hero__arrow--prev');
        const nextButton = hero.querySelector('.hero__arrow--next');
        const slider = hero.querySelector('.hero__slider');

        if (slides.length === 0) return;

        // Get settings from data attributes
        const autoplayEnabled = hero.dataset.autoplay === 'true' && !isDesignMode;
        const autoplayDelaySeconds = parseInt(hero.dataset.autoplayDelay, 10);
        const autoplayDelay = Number.isFinite(autoplayDelaySeconds) ? autoplayDelaySeconds * 1000 : 5000;

        initCarousel(hero, slides, dots, prevButton, nextButton, slider, autoplayEnabled, autoplayDelay);
    }

    function initAllHeroes(root) {
        const scope = root || document;
        const heroes = scope.querySelectorAll('[data-hero-carousel]');
        if (heroes.length === 0) return;
        heroes.forEach(initHero);
    }

    initAllHeroes(document);

    document.addEventListener('shopify:section:load', (event) => {
        initAllHeroes(event.target);
    });

    function initCarousel(hero, slides, dots, prevButton, nextButton, slider, autoplayEnabled, autoplayDelay) {
        let currentSlide = 0;
        let autoplayInterval = null;
        let touchStartX = 0;
        let touchEndX = 0;

        // Start from server-rendered active slide to avoid initial repaint flash
        const initiallyActive = Array.from(slides).findIndex((slide) => slide.classList.contains('hero__slide--active'));
        if (initiallyActive >= 0) {
            currentSlide = initiallyActive;
        }

        function updateDots(index) {
            dots.forEach((dot, dotIndex) => {
                dot.classList.toggle('hero__dot--active', dotIndex === index);
            });
        }

        // Show specific slide
        function showSlide(index) {
            if (index === currentSlide) {
                updateDots(index);
                return;
            }

            const previousSlide = slides[currentSlide];
            const nextSlide = slides[index];
            if (!nextSlide) return;

            // Remove active class from all slides and dots
            if (previousSlide) {
                previousSlide.classList.remove('hero__slide--active');
                if (isDesignMode) {
                    previousSlide.hidden = true;
                }
            }

            nextSlide.classList.add('hero__slide--active');
            if (isDesignMode) {
                nextSlide.hidden = false;
            }

            currentSlide = index;
            updateDots(index);
        }

        // Navigate to next/previous slide
        function navigateSlide(direction) {
            let newIndex = currentSlide + direction;

            if (newIndex < 0) {
                newIndex = slides.length - 1;
            } else if (newIndex >= slides.length) {
                newIndex = 0;
            }

            goToSlide(newIndex);
        }

        // Go to specific slide
        function goToSlide(index) {
            if (index >= 0 && index < slides.length) {
                showSlide(index);
                resetAutoplay();
            }
        }

        // Autoplay functionality
        function startAutoplay() {
            stopAutoplay();
            if (autoplayEnabled) {
                autoplayInterval = setInterval(() => {
                    navigateSlide(1);
                }, autoplayDelay);
            }
        }

        function stopAutoplay() {
            if (autoplayInterval) {
                clearInterval(autoplayInterval);
                autoplayInterval = null;
            }
        }

        function resetAutoplay() {
            stopAutoplay();
            if (autoplayEnabled) {
                startAutoplay();
            }
        }

        // Touch/swipe handlers
        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance for a swipe
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swipe left - next slide
                    navigateSlide(1);
                } else {
                    // Swipe right - previous slide
                    navigateSlide(-1);
                }
            }
        }

        // Initialize this carousel without forcing a full class reset
        slides.forEach((slide, index) => {
            const isActive = index === currentSlide;
            slide.classList.toggle('hero__slide--active', isActive);
            if (isDesignMode) {
                slide.hidden = !isActive;
            }
        });
        updateDots(currentSlide);
        // Set up event listeners
        if (prevButton) {
            prevButton.addEventListener('click', () => navigateSlide(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateSlide(1));
        }

        // Set up dot navigation
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => goToSlide(index));
        });

        // Touch/swipe support
        if (slider) {
            slider.addEventListener('touchstart', handleTouchStart, { passive: true });
            slider.addEventListener('touchend', handleTouchEnd, { passive: true });
        }

        // Start autoplay if enabled
        if (autoplayEnabled) {
            startAutoplay();

            // Pause autoplay on hover
            hero.addEventListener('mouseenter', stopAutoplay);
            hero.addEventListener('mouseleave', startAutoplay);
        }
    }
})();
